// Use require to match dmsbasereact's CJS import and avoid dual package hazard
// (otherwise toast() would register in a different singleton than ToastContainer)
const { toast } = require("react-toastify");

const isReactElement = (o) => o != null && typeof o === "object" && o.$$typeof !== undefined;
const isPlainObject = (o) => o != null && typeof o === "object" && !isReactElement(o) && !Array.isArray(o);

export const NotificationsLena = {
    TYPE_DEFAULT: toast.TYPE.DEFAULT,
    TYPE_INFO: toast.TYPE.INFO,
    TYPE_SUCCESS: toast.TYPE.SUCCESS,
    TYPE_WARNING: toast.TYPE.WARNING,
    TYPE_ERROR: toast.TYPE.ERROR,

    THEME_LIGHT: "light",
    THEME_DARK: "dark",
    THEME_COLORED: "colored",

    toast(title_or_opts, type = null, loading = false, timeout = 2000, theme = null) {
        let title = title_or_opts;
        if (isPlainObject(title_or_opts)) {
            const opts = title_or_opts;
            title = opts.title;
            type = opts.type || type;
            loading = opts.loading || loading;
            timeout = opts.timeout !== undefined ? opts.timeout : timeout;
            theme = opts.theme || theme;
        }

        if (!type) type = NotificationsLena.TYPE_DEFAULT;
        if (!theme) theme = NotificationsLena.THEME_LIGHT;

        const options = {
            position: "top-right",
            autoClose: timeout || false,
            hideProgressBar: timeout === 0,
            type,
            closeOnClick: true,
            pauseOnHover: false,
            theme,
        };

        return loading ? toast.loading(title, options) : toast(title, options);
    },

    clearToast(id) {
        toast.dismiss(id);
    },
};
